import { render, staticRenderFns } from "./itemAction.vue?vue&type=template&id=37bef202&scoped=true&"
import script from "./itemAction.vue?vue&type=script&lang=js&"
export * from "./itemAction.vue?vue&type=script&lang=js&"
import style0 from "./itemAction.vue?vue&type=style&index=0&id=37bef202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bef202",
  null
  
)

export default component.exports